<script>
	import Button from "../../components/Button.svelte";
	import Icon from "../../Icon.svelte";
	
	function buttonWidth(pc, tablet, mobile) {
		if(window.innerWidth <= 480) return mobile
		if(window.innerWidth <= 640) return tablet
		return pc
	}
	function buttonHeight(pc, tablet, mobile) {
		if(window.innerWidth <= 480) return mobile
		if(window.innerWidth <= 640) return tablet
		return pc
	}

	let button1 = {
		width: buttonWidth('138px','104px','75px'),
		height: buttonHeight('38px', '27px', '22px'),
		icon: window.innerWidth <= 640 ? '' : 'link'
	}
	let button2 = {
		width: buttonWidth('151px','117px','75px'),
		height: buttonHeight('38px', '27px', '86px'),
		icon: window.innerWidth <= 640 ? '' : 'widget'
	}
	let button3 = {
		width: buttonWidth('115px','81px','75px'),
		height: buttonHeight('38px', '27px', '55px'),
		icon: window.innerWidth <= 640 ? '' : 'share'
	}
	let button4 = {
		width: buttonWidth('127px','93px','75px'),
		height: buttonHeight('38px', '27px', '66px'),
		icon: window.innerWidth <= 640 ? '' : 'horizontal-switch'
	}
</script>
<section class="section dispatcher">
	<div class="container">
		<div class="dispatcher__row dispatcher__row--first">
			<h2 class="h1 dispatcher__title b">Our Computer-Aided Dispatch System</h2>
			<div class="dispatcher__tags">
				<div class="dispatcher__tag">
					<span><Icon name='link'/></span>
					Innovation
				</div>
				<div class="dispatcher__tag">
					<span><Icon name='widget'/></span>
					Functionality
				</div>
				<div class="dispatcher__tag">
					<span><Icon name='share'/></span>
					Simple
				</div>
				<div class="dispatcher__tag">
					<span><Icon name='horizontal-switch'/></span>
					Integrate
				</div>
			</div>
		</div>
		<div class="dispatcher__row dispatcher__row--second">
			<img src="../assets/img/dispatcher-circle.png" alt="Circle" class="dispatcher__circle">
			<div class="dispatcher__info">
				<p class="h5 dispatcher__text">There are so many features available in Loder that make dispatchers’ daily workload easier and more manageable.</p>
				<p class="h5 dispatcher__text">Loder automates as many tasks in the trucking dispatch business as possible, and these software solutions directly benefit dispatchers and reduce human work hours for trucking company owners. Check out a few of Loder’s amazing features:</p>
				<p class="h3 dispatcher__text-blue">Check out a few of Loder’s amazing features:</p>
			</div>
		</div>
	</div>
</section>

<style>
	
	.dispatcher__tag {
		border: 1px solid var(--system-background-tertiary) ;
		padding: 7px 20px;
		border-radius: 10px;
		display: flex;
		align-items: center;
		justify-content: center;
		gap: 10px;
		color: var(--color-primary-500)
	}
	.dispatcher__text-blue {
		color: var(--color-primary-500);
		margin: 35px 0 0;
	}
	.dispatcher__info {
		display: flex;
		flex-direction: column;
		gap: 35px;
		margin: 0 0 70px;
		max-width: 561px;
	}
	.dispatcher__text {
		color: var(--text-color-secondary);
		margin: 0;
	}
	.dispatcher__title {
		max-width: 490px;
		top: 0;
		margin: 0;
	}
	.dispatcher__tags {
		display: flex;
		gap: 10px;
	}
	.dispatcher__circle {
		width: 100%;
		max-width: 300px;
		height: auto;
		display: block;
	}
	.dispatcher__row {
		display: flex;
		gap: 100px;
		justify-content: space-between;
	}
	.dispatcher__row--first {
		align-items: flex-end;
		margin-bottom: 64px;
	}
	.dispatcher__row--second {
		align-items: flex-start;
	}
	.section {
		padding: 150px 0;
		background-color: var(--system-background-primary);
	}
	.container {
		max-width: 1320px;
		width: 100%;
		margin: 0 auto;
		padding: 0px 10px;
	}
	@media(max-width: 1200px) {
		.container {
			max-width: 940px;
		}
		.section {
			padding: 120px 0;
		}
		.dispatcher__title {
			font-size: 32px;
			line-height: 40px;
		}
		.dispatcher__info {
			gap: 25px;
			margin: 0 0 60px;
		}
		.dispatcher__text {
			font-size: 16px;
			line-height: 20px;
		}
		.dispatcher__text-blue {
			font-size: 24px;
			line-height: 30px;
		}
	}
	@media(max-width: 960px) {
		.container {
			max-width: 620px;
		}
		.dispatcher__title {
			max-width: 100%;
		}
		.dispatcher__row--first {
			flex-direction: column;
			gap: 25px;
			margin-bottom: 60px;
			align-items: flex-start;
		}
		.dispatcher__row--second {
			gap: 84px;
		}
		.dispatcher__info {
			gap: 15px;
		}
		.dispatcher__circle {
			max-width: 236px;
		}
	}
	@media(max-width: 640px) {
		.container {
			max-width: 460px;
		}
		.section {
			padding: 100px 0;
		}
		.dispatcher__title {
			font-size: 24px;
			line-height: 30px;
		}
		.dispatcher__row--second {
			flex-direction: column;
			gap: 50px;
		}
		.dispatcher__circle {
			width: 320px;
			height: 254px;
			margin: 0 auto;
			display: block;
		}
		.dispatcher__text {
			font-size: 14px;
			line-height: 17px;
		}
		.dispatcher__text-blue {
			font-size: 20px;
			line-height: 25px;
		}
		.dispatcher__tag span {
			display: none;
		}
		.dispatcher__tag {
			padding: 5px 20px;
		}
	}
	@media(max-width: 480px) {
		.container {
			max-width: 300px;
		}
		.section {
			padding: 70px 0;
		}
		.dispatcher__circle {
			width: 267px;
			height: 246px;
			margin: 0 auto;
			display: block;
		}
		.dispatcher__tags {
			gap: 5px;
		}
		.dispatcher__tag {
			padding: 4px 10px;
			font-size: 12px;
			line-height: 14px;
		}
		:global(.dispatcher__outlined .big) {
			font-size: 12px;
			line-height: 14px;
		}
	}
</style>